<div class="row fuelux">
  <div class="col-lg-12">
    <div class="main-box clearfix">
      <div class="main-box-body clearfix wizardmainbox">
        <div class="row">
          <div class="col-lg-12">
            <div class="main-box clearfix" style="min-height: 200px;">
              <div class="row">
                <form role="form" name="bulkResumeUploadForm" novalidate>
                  <!-- Source Type and Other Options - Left Side -->
                  <div class="col-lg-5 col-lg-offset-1" style="margin-top: 2%; padding: 0 20px 20px 20px;">
                    <!-- Source Type Selection -->
                    <div class="form-group">
                      <label for="sourceType" class="control-label">
                        Source Type <em>*</em>:
                      </label>
                      <select 
                        class="form-control" 
                        id="sourceType"
                        [(ngModel)]="sourceType"
                        (change)="sourceTypeChanged()"
                        [disabled]="disableSourceTypesFlag || fileUploadInProgressFlag"
                        name="sourceType"
                        required>
                        <option [ngValue]="undefined" disabled>Select</option>
                        <option *ngFor="let source of sourceTypeList" [ngValue]="source">
                          {{ source.sourceType }}
                        </option>
                      </select>
                    </div>

                    <!-- Other Source Type Notes -->
                    <div class="form-group" *ngIf="sourceType && sourceType.sourceType === 'Other'">
                      <label for="otherSourceTypeNotes" class="control-label">
                        Notes <em>*</em>:
                      </label>
                      <textarea 
                        class="form-control" 
                        id="otherSourceTypeNotes"
                        [(ngModel)]="otherSourceTypeNotes"
                        maxlength="503"
                        placeholder="Enter notes for other source type"
                        [disabled]="disableSourceTypesFlag || fileUploadInProgressFlag"
                        name="otherSourceTypeNotes"
                        required></textarea>
                    </div>

                    <!-- Referrer Details for Referral -->
                    <div class="form-group" *ngIf="sourceType && sourceType.sourceType === 'Referral'">
                      <label for="referrerName" class="control-label">
                        Referrer Name <em>*</em>:
                      </label>
                      <input 
                        type="text" 
                        class="form-control" 
                        id="referrerName"
                        [(ngModel)]="referrerName"
                        placeholder="Enter referrer name"
                        [disabled]="disableSourceTypesFlag || fileUploadInProgressFlag"
                        name="referrerName"
                        required>
                    </div>

                    <div class="form-group" *ngIf="sourceType && sourceType.sourceType === 'Referral'">
                      <label for="referrerEmail" class="control-label">
                        Referrer Email <em>*</em>:
                      </label>
                      <input 
                        type="email" 
                        class="form-control" 
                        id="referrerEmail"
                        [(ngModel)]="referrerEmail"
                        placeholder="example@example.com"
                        [disabled]="disableSourceTypesFlag || fileUploadInProgressFlag"
                        name="referrerEmail"
                        required>
                      <span class="help-block">ex. example@example.com</span>
                    </div>
                  </div>

                  <!-- Upload Date Selection - Right Side -->
                  <div class="col-lg-4 col-lg-offset-1" style="margin-top: 2%; padding: 0px 26px 20px 20px;">
                    <div class="form-group">
                      <label for="displayUploadDate" class="control-label">
                        Upload Date <em>*</em>:
                      </label>
                      <div class="input-group">
                        <span class="input-group-addon" [class.cursor-pointer]="!fileUploadInProgressFlag" (click)="openDatePicker()">
                          <i class="fa fa-calendar"></i>
                        </span>
                        <input 
                          type="text" 
                          class="form-control" 
                          id="displayUploadDate"
                          [(ngModel)]="displayUploadDate"
                          (change)="onUploadDateChange()"
                          placeholder="mm-dd-yyyy"
                          [disabled]="fileUploadInProgressFlag"
                          name="displayUploadDate">
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <div class="main-box-body clearfix col-lg-10 col-lg-offset-1">
                <div class="bru-dropzone">
                  <div class="bru-title">Drop more files or folders here</div>
                  <div class="bru-actions">
                    <button type="button" class="btn btn-default bru-btn" (click)="fileInput.click()" [disabled]="fileUploadInProgressFlag">
                      <i class="fa fa-file"></i> Choose files
                    </button>
                    <button type="button" class="btn btn-default bru-btn" (click)="folderInput.click()" [disabled]="fileUploadInProgressFlag">
                      <i class="fa fa-folder"></i> Choose folder
                    </button>
                  </div>
                </div>
                <input #fileInput type="file" class="hidden" multiple accept=".pdf,.xlsx,.docx,.doc" (change)="onPicked(fileInput)">
                <input #folderInput type="file" class="hidden" multiple webkitdirectory (change)="onPicked(folderInput)">

                <div class="bru-summary">
                  <strong>Selected: {{ totalFilesCount() }} {{ totalFilesCount() === 1 ? 'resume' : 'resumes' }}</strong>
                  <span class="bru-chip" *ngIf="folderCount() > 0">{{ folderCount() }} {{ folderCount() === 1 ? 'folder' : 'folders' }}</span>
                  <span class="bru-chip" *ngIf="looseFileCount() > 0">{{ looseFileCount() }} {{ looseFileCount() === 1 ? 'file' : 'files' }}</span>
                  <span class="bru-chip bru-chip-warn" *ngIf="skippedFiles.length > 0">{{ skippedFiles.length }} skipped</span>
                  <span class="bru-spacer"></span>
                  <button type="button" class="bru-link" (click)="clearAllDirectories()" [disabled]="fileUploadInProgressFlag">Clear all</button>
                </div>

                <div class="bru-list">
                  <ng-container *ngFor="let directory of selectedDirectories; let i = index">
                    <div class="bru-row" *ngIf="!isDefaultDirectory(directory)">
                      <span class="bru-ico"><i class="fa fa-folder"></i></span>
                      <span class="bru-name" [title]="directory.directoryName">{{ directory.directoryName }} / ({{ directory.files.length }} {{ directory.files.length === 1 ? 'file' : 'files' }})</span>
                      <span class="bru-meta">{{ formatSize(directorySize(directory)) }}</span>
                      <button type="button" class="bru-remove" title="Remove" (click)="removeDirectory(i)" [disabled]="fileUploadInProgressFlag">&times;</button>
                    </div>
                    <ng-container *ngIf="isDefaultDirectory(directory)">
                      <div class="bru-row" *ngFor="let file of directory.files">
                        <span class="bru-ico"><i class="fa fa-file"></i></span>
                        <span class="bru-name" [title]="file.name">{{ file.name }}</span>
                        <span class="bru-meta">{{ formatSize(file.size) }}</span>
                        <button type="button" class="bru-remove" title="Remove" (click)="removeFile(directory, file)" [disabled]="fileUploadInProgressFlag">&times;</button>
                      </div>
                    </ng-container>
                  </ng-container>
                  <div class="bru-row bru-row-dup" *ngFor="let dup of duplicateFiles; let i = index">
                    <span class="bru-ico"><i class="fa fa-file"></i></span>
                    <span class="bru-name" [title]="dup.name">{{ dup.name }}</span>
                    <span class="bru-meta">duplicate, will be ignored</span>
                    <button type="button" class="bru-remove" title="Remove" (click)="removeDuplicate(i)" [disabled]="fileUploadInProgressFlag">&times;</button>
                  </div>
                  <div class="bru-row bru-row-warn" *ngFor="let skipped of skippedFiles; let i = index">
                    <span class="bru-ico"><i class="fa fa-exclamation-triangle"></i></span>
                    <span class="bru-name" [title]="skipped.name">{{ skipped.name }}</span>
                    <span class="bru-meta">{{ skipped.reason }}</span>
                    <button type="button" class="bru-remove" title="Remove" (click)="removeSkipped(i)" [disabled]="fileUploadInProgressFlag">&times;</button>
                  </div>
                </div>

                <div class="bru-footer">
                  <span class="bru-note">Files and folders are uploaded together</span>
                  <button type="button" class="btn btn-primary" id="uploadFile" (click)="startBulkUpload()" [disabled]="disableUploadButtonFlag">
                    <span *ngIf="!fileUploadInProgressFlag">Upload {{ totalFilesCount() }} {{ totalFilesCount() === 1 ? 'resume' : 'resumes' }}</span>
                    <span *ngIf="fileUploadInProgressFlag">Uploading...</span>
                  </button>
                </div>
              </div>
              <div class="row" style="margin-bottom: 200px"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
